import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { VENDOR_ORDER_SOLD_AND_PURCHASE_TABS } from 'utils/constants';
import CustomTabs from 'components/CustomTabs';
import ErrorBoundary from 'components/common/ErrorBoundary';
import VendorOrderSold from '../VendorOrderSold';
import VendorOrderPurchase from '../VendorOrderPurchase';

const VendorOrderSoldAndPurchase = () => {
  const [activeTab, setActiveTab] = useState(
    VENDOR_ORDER_SOLD_AND_PURCHASE_TABS.SOLD,
  );
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {' '}
      <div className="d-flex align-items-center">
        <CustomTabs
          tabs={[
            VENDOR_ORDER_SOLD_AND_PURCHASE_TABS.SOLD,
            VENDOR_ORDER_SOLD_AND_PURCHASE_TABS.PURCHASED,
          ]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="border-0 inner-list-tab"
        />
      </div>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={VENDOR_ORDER_SOLD_AND_PURCHASE_TABS.SOLD}>
          {activeTab === VENDOR_ORDER_SOLD_AND_PURCHASE_TABS.SOLD && (
            <ErrorBoundary>
              <VendorOrderSold />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={VENDOR_ORDER_SOLD_AND_PURCHASE_TABS.PURCHASED}>
          {activeTab === VENDOR_ORDER_SOLD_AND_PURCHASE_TABS.PURCHASED && (
            <ErrorBoundary>
              <VendorOrderPurchase />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default VendorOrderSoldAndPurchase;
